export default {
  filters: {
    formatNumber: function(value) {
      const million = 1000 * 1000;
      const billion = 1000 * million;
      const nf = new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 });

      if (!value) {
        return '';
      } else if (value >= billion) {
        return nf.format(value / billion) + 'B';
      } else if (value >= million) {
        return nf.format(value / million) + 'M';
        // } else if (value >= 1000) {
        //     return nf.format(value / 1000) + 'K'
      } else {
        return nf.format(value);
      }
    },
    formatComaDot: function(value) {
      if (value === null) return '0';
      return Number(value).toLocaleString('en-US');
    }
  },
};
